import * as THREE from 'three';
import TankActor from './actors/TankActor';
import { IActor } from './types';

export type PlayerType = 'tank';

export default class ActorFactory {
  static create(
    type: PlayerType,
    scene: THREE.Scene,
    collidables: THREE.Object3D[],
    name: string,
    userId: string,
    color: string
  ): IActor {
    switch (type) {
      case 'tank':
      default:
        return new TankActor(scene, collidables, name, userId, color);
    }
  }
}

